module.exports = __webpack_public_path__ + "img/513.60b01f90.png";